export default "__VITE_ASSET__BcMUoiO7__"